import React, {useEffect, useState} from "react";

import axios from "config/axiosConfig";
import {Link} from "react-router-dom";

export default function Main() {
    const [contents, setContents] = useState([]);

    const requestSearch = () => {
        axios.get(`/admin/knowledge-s`)
            .then((res) => {
                setContents(res.data);
            });
    }

    const requestDelete = (id) => {
        axios.delete(`/admin/knowledge-s/${id}`)
            .then((res) => {
                window.location.reload();
            });
    }

    useEffect(() => {
        requestSearch()
    }, []);

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">메인화면-노무지식</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-tools">
                                            <div style={{float: "right"}}>
                                                <Link to={`/page/app/knowledge/detail`}>
                                                    <button type="button"
                                                            className="btn btn-outline-primary btn-sm"
                                                            style={{width: '70px', marginRight: '20px', marginTop: '20px'}}>
                                                        추가
                                                    </button>
                                                </Link>
                                            </div>
                                        </div>

                                        <div className="card-body table-responsive p-0" style={{marginTop: '20px'}}>
                                            <table className="table table-hover text-nowrap"
                                                   style={{textAlign: "center"}}>
                                                <thead>
                                                <tr>
                                                    <th>ID</th>
                                                    <th>제목</th>
                                                    <th>부제목</th>
                                                    <th>등록일</th>
                                                    <th>노출여부</th>
                                                    <th>링크</th>
                                                    <th>수정</th>
                                                    <th>삭제</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    contents.map(item => {
                                                        return (
                                                            <tr>
                                                                <td>{item.id}</td>
                                                                <td>{item.title}</td>
                                                                <td>{item.subTitle}</td>
                                                                <td>{item.createdAt}</td>
                                                                <td>{item.visible ? 'O' : 'X'}</td>
                                                                <td>
                                                                    <table className="table table-hover text-nowrap">
                                                                        {
                                                                            item.links.map(link => {
                                                                                return (
                                                                                    <tr>
                                                                                        <td>{link.title}</td>
                                                                                        <td>
                                                                                            <Link to={link.link} target="_blank">보기</Link>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                        }
                                                                    </table>
                                                                </td>
                                                                <td>
                                                                    <button type="button"
                                                                            className="btn btn-outline-info">
                                                                        <Link to={`/page/app/knowledge/detail?id=${item.id}`}>수정</Link>
                                                                    </button>
                                                                </td>
                                                                <td>
                                                                    <button type="button"
                                                                            className="btn btn-outline-danger"
                                                                            onClick={ event => requestDelete(item.id)}>
                                                                        삭제
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    )
}